export const RESET_STATE = 'resetState'
export const SET_AUTH = 'setUser'
export const SET_ERROR = 'setError'
export const PURGE_AUTH = 'purgeAuth'
export const SET_CREATED_LIVE_STREAM = 'setCreatedLiveStream'
export const SET_CREATED_STREAMER = 'setCreatedStreamer'
export const SET_STREAMERS = 'setStreamers'
export const SET_ALL_STREAMERS = 'setAllStreamers'
export const SET_STREAMER = 'setStreamer'
export const SET_UPDATED_STREAMER = 'setUpdatedStreamer'
export const SET_USERS = 'setUsers'
export const SET_BANNED_USERS = 'setBannedUsers'
export const SET_LIVE_STREAMS = 'setLiveStreams'
export const SET_CURRENT_LIVE_STREAMS = 'setCurrentLiveStreams'
export const SET_LIVE_STREAM = 'setLiveStream'
export const SET_FAKE_VIEWERS = 'setFakeViewers'
export const SET_IS_LOADING = 'setIsLoading'
export const SET_IS_PINNING_COMMENT = 'setIsPinningComment'
export const SET_COMMENTS = 'setComments'
export const SET_PROFILE_URL = 'setProfileUrl'
export const SET_POLL_QUESTION = 'setPollQuestion'
export const SET_UPDATED_LIVE_STREAM_STATUS = 'setUpdatedLiveStreamStatus'
export const SET_PROFILE = 'setProfile'
export const SET_DASHBOARD = 'setDashboard'
export const SET_UPDATED_PROFILE = 'setUpdatedProfile'
export const SET_NEW_PASSWORD = 'setNewPassword'
export const SET_RESET_PASSWORD = 'setResetPassword'
export const SET_CLUB_LOGO_URL = 'setClubLogoUrl'
export const SET_CREATED_CLUB = 'setCreatedClub'
export const SET_CLUBS = 'setClubs'
export const SET_CLUB = 'setClub'
export const SET_UPDATED_CLUB = 'setUpdatedClub'
export const SET_CREATED_LIVE_SCHEDULE = 'setCreatedLiveSchedule'
export const SET_LIVE_SCHEDULES = 'setLiveSchedules'
export const SET_DELETED_SCHEDULE = 'setDeletedSchedule'
export const SET_LIVE_SCHEDULE = 'setLiveSchedule'
export const SET_CLUBS_FOR_SCHEDULE = 'setClubForSchedule'
export const SET_NOTIFICATIONS = 'sestNotifications'
export const SET_VIDEO_UPLOADED = 'setVideoUploaded'
export const SET_UPLOADING_VIDEO = 'setUploadingVideo'
export const SET_UPLOAD_PERCENTAGE = 'setUploadPercentage'
export const SET_VIDEOS = 'setVideos'
export const SET_VIDEO_STATUS = 'setVideoStatus'
export const SET_CREATED_POST = 'setCreatedPost'
export const SET_POSTS = 'setPosts'
export const SET_POST = 'setPost'
export const SET_POST_COMMENTS = 'setPostComments'
export const SET_UPLOADED_FILE_URL = 'setUploadedFileUrl'
export const SET_EDITORS = 'setEditors'
export const SET_EDITOR = 'setEditor'
export const SET_MODIFIED_DB_CAPACITY = "setModifiedDbCapacity";
export const SET_DB_INFO = "setDbInfo";
